class CommonUtil {
  static renameProperty(object, oldProperty, newProperty) {
    if (object.hasOwnProperty(oldProperty)) {
      Object.defineProperty(
        object,
        newProperty,
        Object.getOwnPropertyDescriptor(object, oldProperty)
      );
      delete object[oldProperty];
    }
    return object;
  }

  static concatStringPropertiesWithSpace(object, propertyNames) {
    var concated = "";

    propertyNames.forEach(propertyName => {
      const space = concated === "" ? "" : " ";
      concated += space + object[propertyName];
    });

    return concated;
  }

  static constructStringArrayWithoutEmpties(...strings) {
    var array = [];

    for (var i = 0; i < strings.length; i++) {
      if (strings[i].length !== 0) {
        array.push(strings[i]);
      }
    }

    return array;
  }

  static getFullName(object) {
    var propertyNames = [];

    if (object.hasOwnProperty("firstName")) {
      propertyNames.push("firstName");
    } else {
      propertyNames.push("name");
    }
    propertyNames.push("lastName");

    return this.concatStringPropertiesWithSpace(object, propertyNames);
  }

  static _checkStringsEmptiness(response, strings) {
    for (var i = 0; i < strings.length; i++) {
      if (strings[i].length === 0) {
        return !response;
      }
    }

    return response;
  }

  static isAnyStringEmpty(strings) {
    return this._checkStringsEmptiness(false, strings);
  }

  static isEveryStringNotEmpty(strings) {
    return this._checkStringsEmptiness(true, strings);
  }

  static _stringMatchRegex(charRegex, string) {
    return charRegex.test(string);
  }

  static stringHasDigit(string) {
    return CommonUtil._stringMatchRegex(/\d/, string);
  }

  static stringHasUpperCasedChar(string) {
    return CommonUtil._stringMatchRegex(/[A-Z]/, string);
  }

  static stringHasLowerCasedChar(string) {
    return CommonUtil._stringMatchRegex(/[a-z]/, string);
  }

  static stringHasSpecialChar(string) {
    return CommonUtil._stringMatchRegex(/[^A-Za-z0-9]/, string);
  }

  static arrayHasObjectWithProperty(array, propertyName, propertyValue) {
    var objectFound = false;

    for (var i = 0; i < array.length; i++) {
      if (
        array[i][propertyName] !== undefined &&
        array[i][propertyName] === propertyValue
      ) {
        objectFound = true;
        break;
      }
    }

    return objectFound;
  }

  static getFirstArrayObjectWithProperty(array, propertyName, propertyValue) {
    for (var i = 0; i < array.length; i++) {
      if (
        array[i][propertyName] !== undefined &&
        array[i][propertyName] === propertyValue
      ) {
        return array[i];
      }
    }
  }

  static formatDate(string) {
    var date = new Date(string);
    return date.toLocaleDateString();
  }

  static formatSystemDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = "" + d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    if (year.length < 4) {
      while (year.length < 4) {
        year = "0" + year;
      }
    }
    return [year, month, day].join("-");
  }

  static formatDateTime(string) {
    if (string) {
      var date = new Date(string);
      const options = {
        day: "numeric",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      };
      return date.toLocaleDateString(navigator.language, options);
    }
    return "";
  }

  static queryParamsGetValueForKey(key, url) {
    key = key.replace(/[[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + key + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  static sortArrayByDateProperty(array, propertyName, direction = "desc") {
    if (array) {
      const sorter = direction === "desc" ? 1 : direction === "asc" ? -1 : 0;

      const sorted = array.sort((o1, o2) => {
        const date1 = new Date(this.getDeep(o1, propertyName));
        const date2 = new Date(this.getDeep(o2, propertyName));

        return date1 < date2 ? sorter : -1 * sorter;
      });

      return sorted;
    }
  }

  static ifNotExternalLinkCreateHttp(text) {
    if (!text) return undefined;
    var regex = "^((http|https|ftp)://)";

    if (!text.match(regex)) {
      return "http://" + text;
    } else {
      return text;
    }
  }

  /**
   * Safely gets deep value.
   */
  static getDeep = (object, path = "") => {
    return path
      .split(".")
      .reduce((o, x) => (o === undefined ? o : o[x]), object);
  };

  /**
   * Dynamically sets a deeply nested value in an object.
   * Optionally "bores" a path to it if its undefined.
   * @function
   * @param {!object} obj  - The object which contains the value you want to change/set.
   * @param {!array} path  - The array representation of path to the value you want to change/set. Use split if you have string value.
   * @param {!mixed} value - The value you want to set it to.
   * @param {boolean} setrecursively - If true, will set value of non-existing path as well.
   */
  static setDeep(obj, path, value, setrecursively = false) {
    if (!path) {
      return;
    }

    let level = 0;

    path.reduce((a, b) => {
      level++;

      if (
        setrecursively &&
        typeof a[b] === "undefined" &&
        level !== path.length
      ) {
        a[b] = {};
        return a[b];
      }

      if (level === path.length) {
        a[b] = value;
        return value;
      } else {
        return a[b];
      }
    }, obj);
  }

  static setDeepOnStringPath(obj, path, value, setrecursively = false) {
    return this.setDeep(obj, path.split("."), value, setrecursively);
  }

  static getNestedUrlWithIds(paths, ids, idsKnown = false) {
    if (
      !paths ||
      !ids ||
      paths.length < ids.length ||
      paths.length > ids.length + 1
    ) {
      throw new Error("IllegalArguments");
    }

    let url = "";
    for (let i = 0; i < paths.length; i++) {
      url += paths[i];
      if (i < ids.length) {
        url += "/";
        if (!idsKnown) {
          url += ":";
        }
        url += ids[i];
      }
    }
    return url;
  }

  static lastIndexOfObjectWithPoperty(array, propertyName, propertyValue) {
    var index = -1;

    for (var i = 0; i < array.length; i++) {
      if (this.getDeep(array[i], propertyName) === propertyValue) {
        index = i;
      }
    }

    return index;
  }

  static arrayContainsObjectWithProperty(array, propertyName, propertyValue) {
    return (
      this.lastIndexOfObjectWithPoperty(array, propertyName, propertyValue) > -1
    );
  }

  static removeElementFromArray(array, element) {
    const index = array.indexOf(element);
    if (index > -1) {
      array.splice(index, 1);
    }
  }

  static findItemInTreeById(tree, id) {
    let item = null;
    if (tree && tree.length > 0) {
      tree.forEach(element => {
        if (element.id === id) {
          item = element;
        } else if (element.children && element.children.length > 0) {
          item = this.findItemInTreeById(element.children, id);
        }
      });
    }
    return item;
  }

  static dateEquals(date1, date2) {
    if (!date1 && !date2) return true;

    const time1 = new Date(date1).getTime();
    const time2 = new Date(date2).getTime();

    return time1 === time2;
  }

  static arraysEquals(arr1, arr2) {
    // Check if the arrays are the same length
    if (arr1.length !== arr2.length) return false;

    // Check if all items exist and are in the same order
    for (var i = 0; i < arr1.length; i++) {
      if (!this.genericEquals(arr1[i], arr2[i])) return false;
    }

    // Otherwise, return true
    return true;
  }

  /**
   * If params are objects they are compared with
   * id property. Only exception is dateFromTo object type.
   * @param {*} obj1
   * @param {*} obj2
   */
  static genericEquals(obj1, obj2) {
    if (obj1 && obj2 && typeof obj1 === "object") {
      if (Array.isArray(obj1)) {
        return this.arraysEquals(obj1, obj2);
      } else if (
        obj1.hasOwnProperty("dateFrom") &&
        obj1.hasOwnProperty("dateTo")
      ) {
        return (
          this.dateEquals(obj1.dateFrom, obj2.dateFrom) &&
          this.dateEquals(obj1.dateTo, obj2.dateTo)
        );
      } else {
        return obj1.id === obj2.id;
      }
    } else {
      return obj1 === obj2;
    }
  }

  static genericEmpty(obj) {
    if (!obj) return true;
    if (typeof obj === "object") {
      if (Array.isArray(obj)) {
        return obj.length ? false : true;
      } else {
        return Object.keys(obj)
          .map(key => obj[key])
          .every(value => this.genericEmpty(value));
      }
    }

    return obj === "";
  }

  static checkValuesChanged(oldEntity, entity) {
    if (oldEntity && entity) {
      return Object.keys(oldEntity)
        .map(key => ({
          oldValue: oldEntity[key],
          value: entity[key]
        }))
        .some(
          property => !this.genericEquals(property.oldValue, property.value)
        );
    } else if (entity) {
      return !this.genericEmpty(entity);
    } else {
      return false;
    }
  }

  static getLastObjectFromArrayWithNestedProperty(
    array,
    propertyName,
    propertyValue
  ) {
    var object = undefined;

    const index = this.lastIndexOfObjectWithPoperty(
      array,
      propertyName,
      propertyValue
    );

    if (index > -1) {
      object = array[index];
    }

    return object;
  }

  static objectHasAnyProperty(object) {
    return object !== undefined && Object.keys(object).length > 0;
  }

  static objectHasAnyDeepProperty(object, subPropertyPath) {
    var hasAnyDeep = false;

    if (object !== undefined) {
      Object.keys(object).forEach(key => {
        const subProperty = this.getDeep(object[key], subPropertyPath);
        if (subProperty !== undefined) {
          hasAnyDeep = true;
        }
      });
    }

    return hasAnyDeep;
  }

  static objectHasProperty(object, propertyName, canBeUndefined = false) {
    var hasProperty = object && object.hasOwnProperty(propertyName);

    if (!canBeUndefined && hasProperty) {
      hasProperty =
        object[propertyName] !== undefined && object[propertyName] !== null;
    }

    return hasProperty;
  }

  static objectsHasSameProperty(object1, object2, propertyName) {
    const property1 = this.getDeep(object1, propertyName);
    const property2 = this.getDeep(object2, propertyName);

    return property1 === property2;
  }

  static constructHeaderTitleAndId(title, id) {
    return id ? `${title} (${id})` : title;
  }

  static concatArrays(...arrays) {
    var result = [];

    for (var i = 0; i < arrays.length; i++) {
      if (arrays[i] !== undefined) {
        result = result.concat(arrays[i]);
      }
    }

    return result;
  }

  static getDataContent(data) {
    if (
      data &&
      data._embedded &&
      data._embedded.content &&
      data._embedded.content.length > 0
    ) {
      return data._embedded.content;
    }
    return undefined;
  }
}
export default CommonUtil;
